import { useQuery } from "react-query";

import { getSpApi } from "./apiRoot";
import { UrlManager } from "./UrlManager";

// Swagger: https://ibpcsrcdev01.portima.net/mybrokerapi/swagger/index.html

/**
 * Returns API Version
 */

export const getAbout = async (): Promise<MyBrokerApi.ProductVersion> => {
    const { data } = await getSpApi().get<MyBrokerApi.ProductVersion>(UrlManager.about());
    return data;
};

export const useQueryAbout = (options = { suspense: false }): MyBrokerApi.ProductVersion => {
    const { data = {} } = useQuery("about", () => getAbout(), options);
    return data;
};
